// Keyed by platformAgentName: `amigo` on FoodAmigos, `assistant` on a partner's dashboard.
export default {
  name: {
    amigo: 'Amigo',
    assistant: 'Avustaja',
  },
  close: {
    amigo: 'Sulje Amigo',
    assistant: 'Sulje avustaja',
  },
  brand: 'Brändi',
  // The header (D4): Chats opens the restaurant's chats in the panel, New chat starts an empty one.
  chats: 'Keskustelut',
  new_chat: 'Uusi keskustelu',
  back: 'Takaisin keskusteluun',
  // Other chats with answers the person hasn't read (QA45): the line under the header leads to Chats.
  news_elsewhere_one: 'Uusia vastauksia toisessa keskustelussa',
  news_elsewhere_other: 'Uusia vastauksia {{count}} muussa keskustelussa',
};
